/* eslint-disable */
require('./ICON_arrow-left')
require('./ICON_ball')
require('./ICON_BIG_smoothing')
require('./ICON_BIG_spineliner')
require('./ICON_BIG_womanback')
require('./ICON_bolt')
require('./ICON_calendar')
require('./ICON_check')
require('./ICON_chevron-left')
require('./ICON_close')
require('./ICON_distortion')
require('./ICON_house')
require('./ICON_kurs')
require('./ICON_leaf')
require('./ICON_list')
require('./ICON_options')
require('./ICON_pacemaker')
require('./ICON_pain')
require('./ICON_pass')
require('./ICON_physio')
require('./ICON_pin')
require('./ICON_plus_circle')
require('./ICON_plus')
require('./ICON_pot')
require('./ICON_protect')
require('./ICON_refresh')
require('./ICON_search')
require('./ICON_skalpell')
require('./ICON_slash')
require('./ICON_spineliner')
require('./ICON_spring')
require('./ICON_staff')
require('./ICON_stetoskop')
require('./ICON_therapie')
require('./ICON_tiles')
require('./ICON_trainer')
require('./ICON_undo')
require('./ICON_user')
require('./ICON_vegan')
require('./ICON_weights-heavy')
require('./ICON_weights-light')
require('./ICON_weights-middle')
require('./ICON_yingyang')



// WEBPACK FOOTER //
// ./src/icons/index.js